export default "<app-station-member-select [selectable]=\"false\"></app-station-member-select>\r\n\r\n\r\n";